(function () {
  const copy = {
    en: {
      methodEyebrow: "Methodology",
      methodTitle: "Testing Method and Instrument-Based Reading",
      methodCopy:
        "This page helps customers quickly estimate roast level and flavor direction. It uses ground coffee color as the default reference for a more stable reading.",
      methodPointInputTitle: "Input Method",
      methodPointInputCopy:
        "Enter an Agtron ground value, a HEX color, or click a preset swatch to estimate the corresponding roast range.",
      methodPointOutputTitle: "Output",
      methodPointOutputCopy:
        "The page returns a likely roast level, flavor direction, mouthfeel balance, and recommended brewing style.",
      methodPointResultTitle: "Interpretation",
      methodPointResultCopy:
        "This tool is for fast education and communication. It is not a replacement for cupping, roast logging, or lab-grade measurement.",
      methodNote:
        "For production and QC, ground coffee is usually more stable than whole bean color, which makes it a better basis for standardized comparison.",
      visualLabelScoop: "Sample ground coffee",
      visualLabelTray: "Level the sample bed",
      visualLabelDevice: "Read with colorimeter",
      instrumentTitle: "From online estimation to powder color measurement",
      instrumentCopy:
        "For roast production, batch comparison, and quality records, visual judgment alone is rarely stable enough. A powder-based color reading gives a more repeatable result and improves internal communication.",
      productButton: "Explore our colorimeter",
      demoButton: "Request a demo",
      inputPanelTitle: "Interactive Input",
      resultPanelTitle: "Analysis",
      agtronLabel: "Agtron Ground Value",
      agtronTip: "Higher values are lighter. Lower values are darker.",
      agtronScaleHigh: "110 light",
      agtronScaleMid: "55 mid",
      agtronScaleLow: "25 dark",
      manualLabel: "Manual Agtron Entry",
      manualAddon: "Ground 25-110",
      hexLabel: "Enter HEX Color",
      hexTip: "Example #9A643A",
      hexMatched: "Matched",
      hexConverted: "HEX converted",
      hexInvalid: "Invalid HEX",
      paletteTitle: "Quick Roast Swatches",
      diagnosisLabel: "Roast diagnosis",
      scoreTitle: "Flavor intensity",
      scoreLabelAcidity: "Acidity",
      scoreLabelSweetness: "Sweetness",
      scoreLabelBitterness: "Bitterness",
      scoreLabelBody: "Body",
      brewTitle: "Recommended brewing and use case",
      whitepaperTitle: "Get the full roast whitepaper",
      ctaTemplate:
        "Download the PDF guide for {roast} and the full roast color comparison chart directly.",
      submitLabel: "Download PDF",
      footnote:
        "This tool estimates roast level and flavor direction. Actual cup character still depends on origin, process, roast curve, brew method, and extraction variables.",
      paletteAriaLabel: "Roast swatches"
    },
    zh: {
      methodEyebrow: "测试方法",
      methodTitle: "测试方法与专业测量",
      methodCopy:
        "这个页面帮助你快速判断咖啡的大体烘焙区间与风味方向，并默认以研磨粉色值作为判断基准。",
      methodPointInputTitle: "输入方式",
      methodPointInputCopy:
        "输入 Agtron 粉值、HEX 色值，或点击预设色卡，系统会将结果映射到对应的烘焙区间。",
      methodPointOutputTitle: "输出结果",
      methodPointOutputCopy:
        "页面会给出接近的烘焙深度、风味方向、口感重心以及推荐冲煮方式。",
      methodPointResultTitle: "结果性质",
      methodPointResultCopy:
        "这是一个用于快速判断和交流的交互工具，不替代杯测、烘焙记录或实验室测量。",
      methodNote:
        "对于生产和质控，研磨粉通常比整豆更容易得到稳定读数，因此更适合作为标准化判断基准。",
      visualLabelScoop: "取样研磨粉",
      visualLabelTray: "压平粉层",
      visualLabelDevice: "色度仪读取",
      instrumentTitle: "从在线判断到粉样色度测量",
      instrumentCopy:
        "对于烘焙生产、批次对比与质量记录，仅依赖肉眼观察通常不够稳定。以研磨粉为基准的专业色度测量，能帮助你获得更一致的颜色读数。",
      productButton: "了解我们的色度仪",
      demoButton: "获取设备演示",
      inputPanelTitle: "交互输入",
      resultPanelTitle: "结果输出",
      agtronLabel: "Agtron 粉值",
      agtronTip: "数值越高越接近浅烘，越低越接近深烘。",
      agtronScaleHigh: "110 极浅",
      agtronScaleMid: "55 平衡",
      agtronScaleLow: "25 深烘",
      manualLabel: "手动输入粉值",
      manualAddon: "粉值 25-110",
      hexLabel: "输入 HEX 色值",
      hexTip: "例如 #9A643A",
      hexMatched: "已匹配",
      hexConverted: "HEX 已换算",
      hexInvalid: "格式错误",
      paletteTitle: "点击色卡快速判断",
      diagnosisLabel: "烘焙判断",
      scoreTitle: "风味强度",
      scoreLabelAcidity: "酸质",
      scoreLabelSweetness: "甜感",
      scoreLabelBitterness: "苦感",
      scoreLabelBody: "醇厚",
      brewTitle: "推荐冲煮与定位",
      whitepaperTitle: "获取完整烘焙度白皮书",
      ctaTemplate: "可直接下载包含 {roast} 解析与完整烘焙色卡对照的 PDF 指南。",
      submitLabel: "直接下载 PDF",
      footnote:
        "本页用于大体判断烘焙区间与风味方向。实际风味仍会受到产地、处理法、烘焙曲线、冲煮参数等因素影响。",
      paletteAriaLabel: "烘焙色卡"
    }
  };

  const roastLevels = [
    {
      agtron: 95,
      key: "light",
      hex: "#D7B48A",
      name: { en: "Light Roast", zh: "极浅烘焙" },
      flavors: { en: ["Floral", "Citrus", "Berry", "Tea-like"], zh: ["花香", "柑橘", "莓果", "茶感"] },
      acidity: 9,
      sweetness: 5,
      bitterness: 2,
      body: 2,
      brew: { en: ["V60", "Kalita", "Iced pour over"], zh: ["V60 手冲", "Kalita", "冰手冲"] },
      description: {
        en: "This is the lightest range. It highlights origin character, floral notes, and bright acidity with a lighter mouthfeel.",
        zh: "这是最浅的烘焙区间，强调花果香与产地个性，口感轻盈，酸质更明显。"
      },
      positioning: {
        en: "Best for drinkers who enjoy clarity, floral-fruity notes, and high-acidity filter coffee.",
        zh: "适合喜欢清晰花果调、轻盈口感与明亮酸质的饮用者。"
      }
    },
    {
      agtron: 85,
      key: "cinnamon",
      hex: "#CD9A63",
      name: { en: "Cinnamon Roast", zh: "肉桂烘焙" },
      flavors: { en: ["Fruit", "Honey", "Citrus", "Light sweetness"], zh: ["花果香", "蜂蜜", "柑橘", "轻甜感"] },
      acidity: 8,
      sweetness: 6,
      bitterness: 2,
      body: 3,
      brew: { en: ["V60", "Origami", "Cold drip"], zh: ["V60 手冲", "Origami", "冰滴"] },
      description: {
        en: "Slightly more developed than the lightest roast, with extra sweetness while still keeping a bright, lively cup.",
        zh: "相比极浅烘，这一档多了一些糖化与甜感，依然保留明亮酸质。"
      },
      positioning: {
        en: "Best for drinkers who want a fresh profile without an overly sharp finish.",
        zh: "适合喜欢清爽风味，但不想太尖锐的饮用者。"
      }
    },
    {
      agtron: 75,
      key: "medium",
      hex: "#BA814C",
      name: { en: "Medium Roast", zh: "中度烘焙" },
      flavors: { en: ["Stone fruit", "Caramel", "Ripe fruit", "Light cocoa"], zh: ["核果", "焦糖", "熟果", "轻巧克力"] },
      acidity: 7,
      sweetness: 7,
      bitterness: 3,
      body: 4,
      brew: { en: ["V60", "Clever", "Aeropress"], zh: ["V60 手冲", "聪明杯", "爱乐压"] },
      description: {
        en: "A more balanced profile with softer acidity and greater accessibility for everyday specialty coffee drinkers.",
        zh: "酸甜更平衡，入口更柔和，适合更广泛的精品咖啡饮用场景。"
      },
      positioning: {
        en: "Best for drinkers who want balance, sweetness, and an easy entry into specialty flavor.",
        zh: "适合喜欢酸甜平衡、风味干净且易入口的饮用者。"
      }
    },
    {
      agtron: 65,
      key: "high",
      hex: "#A86B3D",
      name: { en: "High Roast", zh: "高度烘焙" },
      flavors: { en: ["Nutty", "Caramel", "Milk chocolate", "Rounded sweetness"], zh: ["坚果", "焦糖", "牛奶巧克力", "圆润甜感"] },
      acidity: 6,
      sweetness: 7,
      bitterness: 4,
      body: 5,
      brew: { en: ["Pour over", "French press", "Americano"], zh: ["手冲", "法压", "美式"] },
      description: {
        en: "Rounded and highly approachable, with enough sweetness and roast development to satisfy a wide audience.",
        zh: "风味圆润，接受度高，既保留层次，也不会让人觉得酸度过强。"
      },
      positioning: {
        en: "Best for drinkers who want a smooth and rounded cup with clear sweetness.",
        zh: "适合喜欢顺滑、圆润、甜感明显的饮用者。"
      }
    },
    {
      agtron: 55,
      key: "city",
      hex: "#935B34",
      name: { en: "City Roast", zh: "城市烘焙" },
      flavors: { en: ["Caramel", "Roasted nuts", "Cocoa", "Balanced body"], zh: ["焦糖", "烤坚果", "可可", "均衡厚度"] },
      acidity: 5,
      sweetness: 7,
      bitterness: 5,
      body: 6,
      brew: { en: ["Americano", "Espresso", "French press"], zh: ["美式", "意式", "法压"] },
      description: {
        en: "A balanced medium-dark range where sweetness, nutty notes, and cocoa become easier for most customers to enjoy.",
        zh: "这是一个偏平衡的中深烘区间，甜感、坚果调与可可感更容易被多数顾客接受。"
      },
      positioning: {
        en: "Best for drinkers who want stability, sweetness, and enough body for multiple brew styles.",
        zh: "适合喜欢稳、甜、厚度适中且适配多种冲煮方式的饮用者。"
      }
    },
    {
      agtron: 45,
      key: "fullcity",
      hex: "#734320",
      name: { en: "Full-City Roast", zh: "全城市烘焙" },
      flavors: { en: ["Dark chocolate", "Caramelized sugar", "Nut paste", "Dense body"], zh: ["黑巧", "糖化感", "坚果酱", "厚实口感"] },
      acidity: 3,
      sweetness: 6,
      bitterness: 6,
      body: 7,
      brew: { en: ["Espresso", "Milk drinks", "Moka pot"], zh: ["意式", "奶咖", "摩卡壶"] },
      description: {
        en: "A heavier, sweeter, and more caramelized roast suited to low-acidity preferences and milk-based drinks.",
        zh: "这一档明显偏向厚重与糖化，适合想要低酸、浓郁和更强醇厚度的用户。"
      },
      positioning: {
        en: "Best for drinkers who prefer richer, deeper roast notes and milk compatibility.",
        zh: "适合喜欢浓郁、厚实、适合奶咖的饮用者。"
      }
    },
    {
      agtron: 35,
      key: "french",
      hex: "#4D2915",
      name: { en: "French Roast", zh: "法式烘焙" },
      flavors: { en: ["Smoky", "Dark chocolate", "Spice", "Heavy bitterness"], zh: ["烟熏", "深色巧克力", "香料", "厚苦感"] },
      acidity: 2,
      sweetness: 4,
      bitterness: 8,
      body: 8,
      brew: { en: ["Espresso", "Latte", "Moka pot"], zh: ["意式", "拿铁", "摩卡壶"] },
      description: {
        en: "Roast character dominates here, with stronger bitterness, lower acidity, and a heavier texture.",
        zh: "风味已经明显由烘焙主导，苦感和厚重度都更强，适合与牛奶结合。"
      },
      positioning: {
        en: "Best for drinkers who want deep roast character, low acidity, and strong body.",
        zh: "适合喜欢深烘、低酸、厚重口感的饮用者。"
      }
    },
    {
      agtron: 25,
      key: "italian",
      hex: "#2D1710",
      name: { en: "Italian Roast", zh: "意式烘焙" },
      flavors: { en: ["Charred", "Carbon", "Heavy oil", "Strong roast"], zh: ["焦苦", "炭烧", "重油脂", "极强烘焙感"] },
      acidity: 1,
      sweetness: 3,
      bitterness: 9,
      body: 9,
      brew: { en: ["Espresso", "Latte", "Cappuccino"], zh: ["浓缩", "拿铁", "卡布奇诺"] },
      description: {
        en: "The darkest roast range, driven by strong roast notes, bitterness, and a heavy mouthfeel rather than fine origin detail.",
        zh: "这是最深的烘焙区间，风味以烘焙感和苦甜感为主，强调力量感而非细腻层次。"
      },
      positioning: {
        en: "Best for drinkers who want a very bold, bitter, and heavy-bodied coffee.",
        zh: "适合喜欢非常浓烈、重苦感与高油脂口感的饮用者。"
      }
    }
  ];

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function normalizeHex(input) {
    const cleaned = String(input || "").trim().replace(/^#/, "");
    if (/^[0-9a-fA-F]{3}$/.test(cleaned)) {
      return "#" + cleaned.split("").map(function (char) {
        return char + char;
      }).join("").toUpperCase();
    }

    if (/^[0-9a-fA-F]{6}$/.test(cleaned)) {
      return "#" + cleaned.toUpperCase();
    }

    return null;
  }

  function hexToRgb(hex) {
    const normalized = normalizeHex(hex);
    if (!normalized) return null;

    const clean = normalized.slice(1);
    return {
      r: parseInt(clean.slice(0, 2), 16),
      g: parseInt(clean.slice(2, 4), 16),
      b: parseInt(clean.slice(4, 6), 16)
    };
  }

  function rgbToHex(rgb) {
    return (
      "#" +
      [rgb.r, rgb.g, rgb.b]
        .map(function (channel) {
          return clamp(Math.round(channel), 0, 255).toString(16).padStart(2, "0");
        })
        .join("")
        .toUpperCase()
    );
  }

  function mixColor(hexA, hexB, ratio) {
    const a = hexToRgb(hexA);
    const b = hexToRgb(hexB);

    return rgbToHex({
      r: a.r + (b.r - a.r) * ratio,
      g: a.g + (b.g - a.g) * ratio,
      b: a.b + (b.b - a.b) * ratio
    });
  }

  function relativeLuma(rgb) {
    return 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b;
  }

  function getClosestRoastLevel(agtron) {
    return roastLevels.reduce(function (closest, current) {
      return Math.abs(current.agtron - agtron) < Math.abs(closest.agtron - agtron) ? current : closest;
    }, roastLevels[0]);
  }

  function getInterpolatedColor(agtron) {
    const sorted = roastLevels.slice().sort(function (a, b) {
      return b.agtron - a.agtron;
    });

    if (agtron >= sorted[0].agtron) return sorted[0].hex;
    if (agtron <= sorted[sorted.length - 1].agtron) return sorted[sorted.length - 1].hex;

    for (let index = 0; index < sorted.length - 1; index += 1) {
      const upper = sorted[index];
      const lower = sorted[index + 1];

      if (agtron <= upper.agtron && agtron >= lower.agtron) {
        const ratio = (upper.agtron - agtron) / (upper.agtron - lower.agtron);
        return mixColor(upper.hex, lower.hex, ratio);
      }
    }

    return sorted[0].hex;
  }

  function estimateAgtronFromHex(hex) {
    const rgb = hexToRgb(hex);
    if (!rgb) return null;

    const inputLuma = relativeLuma(rgb);
    const luminanceStops = roastLevels
      .map(function (level) {
        return { agtron: level.agtron, luma: relativeLuma(hexToRgb(level.hex)) };
      })
      .sort(function (a, b) {
        return b.agtron - a.agtron;
      });

    if (inputLuma >= luminanceStops[0].luma) return luminanceStops[0].agtron;
    if (inputLuma <= luminanceStops[luminanceStops.length - 1].luma) return luminanceStops[luminanceStops.length - 1].agtron;

    for (let index = 0; index < luminanceStops.length - 1; index += 1) {
      const upper = luminanceStops[index];
      const lower = luminanceStops[index + 1];

      if (inputLuma <= upper.luma && inputLuma >= lower.luma) {
        const span = upper.luma - lower.luma || 1;
        const ratio = (upper.luma - inputLuma) / span;
        return Math.round(upper.agtron - (upper.agtron - lower.agtron) * ratio);
      }
    }

    return 55;
  }

  function resolveLocale(section) {
    const raw = (section.dataset.locale || document.documentElement.lang || "en").toLowerCase();
    return raw.indexOf("zh") === 0 ? "zh" : "en";
  }

  function setText(section, role, value) {
    const node = section.querySelector('[data-role="' + role + '"]');
    if (node) {
      node.textContent = value;
    }
  }

  function initFinder(section) {
    if (section.dataset.initialized === "true") return;
    section.dataset.initialized = "true";

    const locale = resolveLocale(section);
    const localeCopy = copy[locale];
    const state = { agtron: 55 };

    function query(role) {
      return section.querySelector('[data-role="' + role + '"]');
    }

    const palette = query("palette");
    const agtronRange = query("agtron-range");
    const agtronInput = query("agtron-input");
    const hexInput = query("hex-input");
    const hexStatus = query("hex-status");
    const resultRoastName = query("result-roast-name");
    const resultDescription = query("result-description");
    const flavorTags = query("flavor-tags");
    const resultPositioning = query("result-positioning");
    const brewList = query("brew-list");
    const ctaCopy = query("cta-copy");
    const primaryCta = query("primary-cta");

    const meters = {
      acidity: { fill: query("meter-acidity"), score: query("score-acidity") },
      sweetness: { fill: query("meter-sweetness"), score: query("score-sweetness") },
      bitterness: { fill: query("meter-bitterness"), score: query("score-bitterness") },
      body: { fill: query("meter-body"), score: query("score-body") }
    };

    const staticFields = {
      "method-eyebrow": localeCopy.methodEyebrow,
      "method-title": localeCopy.methodTitle,
      "method-copy": localeCopy.methodCopy,
      "method-point-input-title": localeCopy.methodPointInputTitle,
      "method-point-input-copy": localeCopy.methodPointInputCopy,
      "method-point-output-title": localeCopy.methodPointOutputTitle,
      "method-point-output-copy": localeCopy.methodPointOutputCopy,
      "method-point-result-title": localeCopy.methodPointResultTitle,
      "method-point-result-copy": localeCopy.methodPointResultCopy,
      "method-note": localeCopy.methodNote,
      "visual-label-scoop": localeCopy.visualLabelScoop,
      "visual-label-tray": localeCopy.visualLabelTray,
      "visual-label-device": localeCopy.visualLabelDevice,
      "instrument-title": localeCopy.instrumentTitle,
      "instrument-copy": localeCopy.instrumentCopy,
      "product-button": localeCopy.productButton,
      "demo-button": localeCopy.demoButton,
      "input-panel-title": localeCopy.inputPanelTitle,
      "result-panel-title": localeCopy.resultPanelTitle,
      "agtron-label": localeCopy.agtronLabel,
      "agtron-tip": localeCopy.agtronTip,
      "agtron-scale-high": localeCopy.agtronScaleHigh,
      "agtron-scale-mid": localeCopy.agtronScaleMid,
      "agtron-scale-low": localeCopy.agtronScaleLow,
      "manual-label": localeCopy.manualLabel,
      "manual-addon": localeCopy.manualAddon,
      "hex-label": localeCopy.hexLabel,
      "hex-tip": localeCopy.hexTip,
      "palette-title": localeCopy.paletteTitle,
      "diagnosis-label": localeCopy.diagnosisLabel,
      "score-title": localeCopy.scoreTitle,
      "score-label-acidity": localeCopy.scoreLabelAcidity,
      "score-label-sweetness": localeCopy.scoreLabelSweetness,
      "score-label-bitterness": localeCopy.scoreLabelBitterness,
      "score-label-body": localeCopy.scoreLabelBody,
      "brew-title": localeCopy.brewTitle,
      "whitepaper-title": localeCopy.whitepaperTitle,
      "footnote": localeCopy.footnote
    };

    Object.keys(staticFields).forEach(function (key) {
      setText(section, key, staticFields[key]);
    });

    if (palette) {
      palette.setAttribute("aria-label", localeCopy.paletteAriaLabel);
    }

    if (primaryCta) {
      primaryCta.textContent = localeCopy.submitLabel;
      primaryCta.href = section.dataset.downloadUrl || "#";
    }

    function renderPalette(activeAgtron) {
      if (!palette) return;
      palette.innerHTML = "";
      const active = getClosestRoastLevel(activeAgtron);

      roastLevels.forEach(function (level) {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "chip" + (level.agtron === active.agtron ? " is-active" : "");
        button.innerHTML = [
          '<span class="chip-color" style="background:' + level.hex + ';"></span>',
          "<strong>" + level.name[locale] + "</strong>",
          "<span>Agtron " + level.agtron + "</span>"
        ].join("");

        button.addEventListener("click", function () {
          renderResult(level.agtron, "palette");
        });

        palette.appendChild(button);
      });
    }

    function updateMeter(metric, value) {
      const meter = meters[metric];
      if (!meter.fill || !meter.score) return;
      meter.fill.style.width = value * 10 + "%";
      meter.score.textContent = String(value);
    }

    function renderResult(rawAgtron, source) {
      const agtron = clamp(Math.round(Number(rawAgtron) || 55), 25, 110);
      const roast = getClosestRoastLevel(agtron);
      const displayHex = getInterpolatedColor(agtron);

      state.agtron = agtron;
      section.style.setProperty("--result-color", displayHex);

      if (agtronRange) agtronRange.value = String(agtron);
      if (agtronInput) agtronInput.value = String(agtron);
      if (hexInput && source !== "hex") hexInput.value = displayHex;
      if (hexStatus && source !== "hex") hexStatus.textContent = localeCopy.hexMatched;

      if (resultRoastName) resultRoastName.textContent = roast.name[locale];
      if (resultDescription) resultDescription.textContent = roast.description[locale];
      if (resultPositioning) resultPositioning.textContent = roast.positioning[locale];
      if (ctaCopy) ctaCopy.textContent = localeCopy.ctaTemplate.replace("{roast}", roast.name[locale]);

      if (flavorTags) {
        flavorTags.innerHTML = "";
        roast.flavors[locale].forEach(function (item) {
          const tag = document.createElement("span");
          tag.className = "tag";
          tag.textContent = item;
          flavorTags.appendChild(tag);
        });
      }

      if (brewList) {
        brewList.innerHTML = "";
        roast.brew[locale].forEach(function (item) {
          const chip = document.createElement("span");
          chip.className = "brew-item";
          chip.textContent = item;
          brewList.appendChild(chip);
        });
      }

      updateMeter("acidity", roast.acidity);
      updateMeter("sweetness", roast.sweetness);
      updateMeter("bitterness", roast.bitterness);
      updateMeter("body", roast.body);
      renderPalette(agtron);
    }

    if (agtronRange) {
      agtronRange.addEventListener("input", function (event) {
        renderResult(event.target.value, "range");
      });
    }

    if (agtronInput) {
      function commitAgtronInput() {
        const rawValue = agtronInput.value.trim();
        if (rawValue === "") {
          agtronInput.value = String(state.agtron);
          return;
        }
        const parsed = Number(rawValue);
        if (Number.isNaN(parsed)) {
          agtronInput.value = String(state.agtron);
          return;
        }
        renderResult(parsed, "number");
      }

      agtronInput.addEventListener("change", commitAgtronInput);
      agtronInput.addEventListener("blur", commitAgtronInput);
      agtronInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          commitAgtronInput();
        }
      });
    }

    if (hexInput) {
      hexInput.addEventListener("input", function (event) {
        const normalized = normalizeHex(event.target.value);
        if (!normalized) {
          if (hexStatus) hexStatus.textContent = localeCopy.hexInvalid;
          return;
        }

        if (hexStatus) hexStatus.textContent = localeCopy.hexConverted;
        renderResult(estimateAgtronFromHex(normalized), "hex");
        hexInput.value = normalized;
      });
    }

    renderResult(state.agtron, "init");
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-coffee-roast-finder]").forEach(initFinder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
